import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import PagesStepper from '../../../Components/PagesStepper';

const CustomNewPracticeActions = function CustomNewPracticeActions({
  currentPage = 0,
  handleChangePage = () => {},
  max = 1,
  edit = false,
  onCancel = null,
}) {
  const intl = useIntl();
  const nextText = useMemo(() => {
    if (currentPage === max - 1) {
      return edit ? intl.messages.EDIT : intl.messages.INSERT;
    }
    return null;
  });
  return (
    <PagesStepper
      variant="progress"
      currentStep={currentPage}
      handleChangeStep={handleChangePage}
      submitStep={currentPage === max - 1}
      nextText={nextText}
      backText={currentPage === 0 ? intl.messages.CANCEL : null}
      max={max}
      onCancel={onCancel}
    />
  );
};

export default CustomNewPracticeActions;
